"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriversListWidgetNB = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var commonFunctions_1 = require("../../commonFunctions");
var journey_services_1 = require("@ferry/journey-services");
var portal_core_1 = require("@ferry/portal-core");
var reactstrap_1 = require("reactstrap");
var FalconQuestionWidgetBase_1 = require("../FalconQuestionWidgetBase");
var PhRemovalModal = function (_a) {
    var name = _a.name, isOpen = _a.isOpen, toggle = _a.toggle;
    return ((0, jsx_runtime_1.jsxs)(reactstrap_1.Modal, { id: "phRemovalModal", className: "my-2 info-modal", isOpen: isOpen, toggle: toggle, children: [(0, jsx_runtime_1.jsx)(reactstrap_1.ModalHeader, { toggle: toggle, children: (0, jsx_runtime_1.jsxs)("div", { className: "d-flex", children: [(0, jsx_runtime_1.jsx)("img", { className: "d-block mr-3 mb-1 fixed-alert-icon", src: "/".concat(portal_core_1.resourcesHelper.THEME_PATH, "/img/alert-popup.svg"), alt: "Alert icon" }), (0, jsx_runtime_1.jsx)("div", { className: "text-blue-2 font-weight-medium", children: "Sorry..." })] }) }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalBody, { children: (0, jsx_runtime_1.jsxs)("div", { className: "font-weight-light", children: ["...we need ", name, " to be assigned as a driver on your vehicle(s)."] }) }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalFooter, { children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-primary btn-next", onClick: toggle, children: "Ok, I understand" }) })] }));
};
var DriversListWidgetNB = /** @class */ (function (_super) {
    __extends(DriversListWidgetNB, _super);
    function DriversListWidgetNB(props) {
        var _this = _super.call(this, props) || this;
        _this.maxReachedClass = "";
        _this.togglePhRemovalModal = function () {
            _this.setState({
                isPhRemovalModalOpen: !_this.state.isPhRemovalModalOpen
            });
        };
        _this.vehicleIndex = (0, commonFunctions_1.getIndexSetting)("vehicleIndex", _this.getSetting("vehicleIndex", undefined), _this.props.question.type);
        _this.vehicleContext = _this.getSetting("addDriverVehicleContext", true);
        if (_this.vehicleIndex === 0) {
            _this.props.engine.setJourneyState({
                pageIdForNavigation: "additionalCarDetails"
            });
        }
        else {
            _this.props.engine.setJourneyState({
                pageIdForNavigation: "additionalVehicle".concat(_this.vehicleIndex, "AdditionalDetailsPage")
            });
        }
        var vehicle = _this.props.interaction.vehicles[_this.vehicleIndex];
        var allDrivers = [_this.props.interaction.policyHolder].concat(_this.props.interaction.additionalDrivers || []);
        if (!vehicle.driverIds) {
            vehicle.driverIds = Array();
            // Set policy holder as main driver if no drivers set for the vehicle
            if (allDrivers.length === 1) {
                vehicle.mainDriverId = _this.props.interaction.policyHolder.personId;
            }
            for (var _i = 0, allDrivers_1 = allDrivers; _i < allDrivers_1.length; _i++) {
                var d = allDrivers_1[_i];
                vehicle.driverIds.push(d.personId);
                vehicle.numberOfDrivers++;
            }
        }
        var drivers = vehicle.driverIds.map(function (driverId) { return allDrivers.find(function (driver) { return driverId === driver.personId; }); });
        _this.state = {
            vehicle: vehicle,
            drivers: drivers,
            allDrivers: allDrivers,
            isPhRemovalModalOpen: false
        };
        _this.addDriver = _this.addDriver.bind(_this);
        _this.deleteDriver = _this.deleteDriver.bind(_this);
        _this.handleOnClickEvent = _this.handleOnClickEvent.bind(_this);
        return _this;
    }
    DriversListWidgetNB.prototype.renderInputField = function () {
        var _this = this;
        var _a, _b;
        var vehicle = this.props.interaction.vehicles[this.vehicleIndex];
        vehicle.driverIds.length >= 6 ? this.maxReachedClass = "max-reached" : this.maxReachedClass = "";
        var vehicleInformation = "".concat(vehicle.make, " ").concat(vehicle.model, " ").concat(vehicle.registrationNumber);
        var pageId;
        this.vehicleContext ? pageId = "vehicle".concat(this.vehicleIndex, "AddDriverPage") : pageId = "anyVehicleAddDriverPage";
        var interaction = this.props.engine.getInteraction();
        var product = interaction.product;
        var maximumDrivers;
        if (product === journey_services_1.PRODUCT_WOLF_MOTOR) {
            maximumDrivers = 5;
        }
        else {
            maximumDrivers = ((_b = (_a = this.props.interaction) === null || _a === void 0 ? void 0 : _a.uistate) === null || _b === void 0 ? void 0 : _b.isAnnualCoverInteractionInDriveAwayJourney) ? 5 : 1;
        }
        var addAdditionalButton = [];
        if (interaction.additionalDrivers.length >= maximumDrivers) {
            addAdditionalButton.push((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}));
        }
        else {
            addAdditionalButton.push((0, jsx_runtime_1.jsx)("div", { className: "pt-3", children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { className: "btn-link", to: "#", onClick: function () { return _this.props.engine.navigate(pageId, false); }, children: "Add another driver" }) }));
        }
        this.props.interaction.numberOfAdditionalDrivers = interaction.additionalDrivers.length;
        return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)(PhRemovalModal, { name: this.props.interaction.policyHolder.firstName, isOpen: this.state.isPhRemovalModalOpen, toggle: this.togglePhRemovalModal }), (0, jsx_runtime_1.jsxs)("div", { className: "falcon-checkbox form-group checkbox-margin-top-20 driver-list-wdg", children: [(0, jsx_runtime_1.jsxs)("label", { children: ["Who are the drivers of this ", vehicle.make, ", ", vehicle.model, vehicle.registrationNumber && " (".concat(vehicle.registrationNumber, ")"), "?"] }), (0, jsx_runtime_1.jsx)("div", { role: "group", "aria-label": "Who are the drivers of this ".concat((0, commonFunctions_1.trimParenthesesFromString)(vehicleInformation)), children: this.renderDrivers() }), addAdditionalButton, this.getSetting("addDriverVehicleContext", true) &&
                            (0, jsx_runtime_1.jsxs)("p", { className: "pt-3", tabIndex: 0, children: ["You can select ", (0, jsx_runtime_1.jsx)("strong", { children: "max 6" }), " drivers for one car. Please allocate your additional drivers to the correct cars."] })] })] }));
    };
    DriversListWidgetNB.prototype.renderDrivers = function () {
        var _this = this;
        var allDrivers = [this.props.interaction.policyHolder].concat(this.props.interaction.additionalDrivers || []);
        var drivers = [];
        var driverIndex = 0;
        var _loop_1 = function (driver) {
            var pageId;
            driver.personId === this_1.props.interaction.policyHolder.personId ? pageId = "drivingLicenceScan" : pageId = "editAdditionalDriver".concat(driverIndex, "DrivingLicenceScanPage");
            driverIndex = driverIndex + 1;
            drivers.push((0, jsx_runtime_1.jsxs)("div", { className: "d-flex align-items-center", children: [(0, jsx_runtime_1.jsxs)("div", { className: "form-check mr-3 mt-1", onClick: function (e) { return _this.handleOnClickEvent(e, driver.personId); }, children: [(0, jsx_runtime_1.jsx)("input", { className: "custom-control-input ".concat(this_1.isChecked(driver.personId)), type: "checkbox", "aria-label": this_1.getSetting("ariaLabel", ""), onChange: function (e) { return _this.handleOnClickEvent(e, driver.personId); }, value: driver.personId, onDoubleClick: this_1.executeNativeEvent, name: driver.firstName, id: this_1.props.question.name + driver.personId, disabled: !this_1.isChecked(driver.personId) && this_1.props.interaction.vehicles[this_1.vehicleIndex].driverIds.length >= 6, checked: this_1.isChecked(driver.personId) }), (0, jsx_runtime_1.jsx)("label", { className: "custom-control-label", htmlFor: this_1.props.question.name + driver.personId, "aria-label": "Driver ".concat(driver.firstName, " ").concat(driver.lastName), children: (0, jsx_runtime_1.jsx)("div", { id: driver.personId, className: "checkbox-big" }) })] }), (0, jsx_runtime_1.jsxs)("p", { className: "mb-0 driver-name ".concat(this_1.maxReachedClass, " ").concat(this_1.isChecked(driver.personId)), children: [driver.firstName, " ", driver.lastName] }), (0, jsx_runtime_1.jsx)("div", { tabIndex: 0, "aria-label": "Edit driver ".concat(driver.firstName, " ").concat(driver.lastName), className: "pl-2 text-decoration-underline cursor-pointer text-blue-1 edit-driver-link", onClick: function () { return _this.editDriver(pageId, false); }, children: (0, jsx_runtime_1.jsx)("p", { className: "btn-link mb-0", children: "Edit" }) })] }, driver.personId));
        };
        var this_1 = this;
        for (var _i = 0, allDrivers_2 = allDrivers; _i < allDrivers_2.length; _i++) {
            var driver = allDrivers_2[_i];
            _loop_1(driver);
        }
        return drivers;
    };
    DriversListWidgetNB.prototype.handleOnClickEvent = function (event, personId) {
        var _this = this;
        event.preventDefault();
        var interaction = this.props.engine.getInteraction();
        if (personId === interaction.policyHolder.personId) {
            this.setState({
                isPhRemovalModalOpen: true
            });
            return;
        }
        var vehicle = interaction.vehicles[this.vehicleIndex];
        var registeredKeeperId = vehicle.registeredKeeperId;
        var mainDriverId = vehicle.mainDriverId;
        if (registeredKeeperId === personId) {
            this.props.onStateChange("vehicles[".concat(this.vehicleIndex, "].registeredKeeperId"), "");
        }
        if (mainDriverId === personId) {
            this.props.onStateChange("vehicles[".concat(this.vehicleIndex, "].mainDriverId"), "");
        }
        var changed = false;
        if (vehicle.driverIds.length > 1) {
            vehicle.driverIds.forEach(function (driverId) {
                if (driverId === personId) {
                    _this.deleteDriver(personId);
                    changed = true;
                }
            });
        }
        if (!changed && !this.state.vehicle.driverIds.includes(personId) && vehicle.driverIds.length < 6) {
            this.addDriver(personId);
        }
    };
    DriversListWidgetNB.prototype.isChecked = function (checkedDriverId) {
        var vehicle = this.props.interaction.vehicles[this.vehicleIndex];
        var result = false;
        vehicle.driverIds.forEach(function (driverId) {
            if (driverId === checkedDriverId) {
                result = true;
            }
        });
        return result;
    };
    DriversListWidgetNB.prototype.deleteDriver = function (driverPersonId) {
        var _a = this.state, vehicle = _a.vehicle, drivers = _a.drivers;
        var driverIdIndex = vehicle.driverIds.findIndex(function (id) { return id.localeCompare(driverPersonId) === 0; });
        if (driverIdIndex > -1) {
            vehicle.driverIds.splice(driverIdIndex, 1);
        }
        var driverIndex = drivers.findIndex(function (driver) { return driver.personId.localeCompare(driverPersonId) === 0; });
        if (driverIndex > -1) {
            drivers.splice(driverIndex, 1);
        }
        if (vehicle.mainDriverId === driverPersonId) {
            vehicle.mainDriverId = undefined;
        }
        if (vehicle.registeredKeeperId === driverPersonId) {
            vehicle.registeredKeeperId = undefined;
        }
        vehicle.numberOfDrivers -= 1;
        this.setState({
            vehicle: vehicle,
            drivers: drivers
        });
        this.props.onStateChange("vehicles[".concat(this.vehicleIndex, "]"), this.state.vehicle);
        this.executeEvent("change");
        this.changelogRecorder.recordPage("change", this.props, "vehicles[".concat(this.vehicleIndex, "]"));
    };
    DriversListWidgetNB.prototype.addDriver = function (driverPersonId) {
        var _a = this.state, vehicle = _a.vehicle, drivers = _a.drivers;
        vehicle.driverIds.push(driverPersonId);
        vehicle.numberOfDrivers += 1;
        this.setState({
            vehicle: vehicle,
            drivers: drivers
        });
        this.props.onStateChange("vehicles[".concat(this.vehicleIndex, "]"), this.state.vehicle);
        this.executeEvent("change");
        this.changelogRecorder.recordPage("change", this.props, "vehicles[".concat(this.vehicleIndex, "]"));
    };
    DriversListWidgetNB.prototype.editDriver = function (pageId, validate) {
        this.props.engine.navigate(pageId, validate);
        this.props.onStateChange("uistate.editDriverProcess", true);
    };
    return DriversListWidgetNB;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
exports.DriversListWidgetNB = DriversListWidgetNB;
//# sourceMappingURL=DriversListWidgetNB.js.map